import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {withStyles} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import Toggle from './Toggle'
import {ContextConsumer} from '../Context'

const styles = theme => ({
  button: {
    marginLeft: theme.spacing.unit * 2,
    color: theme.palette.grey.contrastText,
    minHeight: 40,
    '&:hover': {
      backgroundColor: theme.palette.grey.main,
    },
    marginRight: 20,
  },
})

class Options extends Component {
  state = {
    anchorEl: null,
  }

  handleClick = event => {
    this.setState({anchorEl: event.currentTarget})
  }

  handleClose = () => {
    this.setState({anchorEl: null})
  }
  render() {
    const {anchorEl} = this.state
    const {classes} = this.props
    return (
      <ContextConsumer>
        {context => {
          return (
            <div className={classes.button}>
              <Button
                variant="raised"
                color="secondary"
                onClick={this.handleClick}>
                <FormattedMessage id="options" />
                <ArrowDownIcon className={classes.rightIcon} />
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}>
                <MenuItem>
                  <Toggle
                    checked={context.sweepstakesPlatformChecked}
                    value="sweepstakesPlatformChecked"
                    label={<FormattedMessage id="sweepstakesPlatform" />}
                  />
                </MenuItem>
                <MenuItem>
                  <Toggle
                    checked={context.showCustomExitUrlInput}
                    value="showCustomExitUrlInput"
                    label={<FormattedMessage id="customExitUrl" />}
                  />
                </MenuItem>
                <MenuItem>
                  <Toggle
                    checked={context.loadLocalhost}
                    value="loadLocalhost"
                    label={<FormattedMessage id="framedLocalhost" />}
                  />
                </MenuItem>
                <MenuItem>
                  <Toggle
                    checked={context.smsAuth}
                    value="smsAuth"
                    label={<FormattedMessage id="smsAuth" />}
                  />
                </MenuItem>
                <MenuItem>
                  <Toggle
                    checked={context.openInIFrameChecked}
                    value="openInIFrameChecked"
                    label={<FormattedMessage id="openInIFrame" />}
                  />
                </MenuItem>
                <MenuItem>
                  <Toggle
                    checked={context.openInNewWindowChecked}
                    value="openInNewWindowChecked"
                    label={<FormattedMessage id="openInNewWindow" />}
                  />
                </MenuItem>
              </Menu>
            </div>
          )
        }}
      </ContextConsumer>
    )
  }
}

Options.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {withTheme: true})(Options)



// WEBPACK FOOTER //
// ./src/components/Options.js